<script setup lang="ts">
  // import { useAppModal } from '@/components/modal'
  import { fmt } from '@/functions'
  import { useDashboard } from '@/models/dashboard'
  import SectionProductWithoutPrice from './section-product-without-price.vue'

  const {
    getData,
    dashboardData,
  } = useDashboard()

  getData()
</script>

<template>
  <div>
    <div class="space-y-8">
      <!-- <app-card title="Pembelian"> -->
      <!-- <div class="flex divide-x"> -->
      <!-- <div class="flex-1 pr-8">
            <div class="font-bold mb-2">
              Belum Dikirim ke Toko
            </div>
            <div class="text-2xl">
              {{ fmt.number(dashboardData?.products_count ?? 0) }}
            </div>
          </div> -->
      <!-- <div class="flex-1 px-8">
            <div class="font-bold mb-2">
              Belum Lunas
            </div>
            <div class="text-2xl">
              {{ fmt.number(dashboardData?.product_variants_count ?? 0) }}
            </div>
          </div> -->
      <!-- <div class="flex-1 px-8"> -->
      <!-- <div class="font-bold mb-2">
              Belum Lunas
            </div>
            <div class="text-2xl">
              {{ fmt.number(dashboardData?.product_variants_count ?? 0) }}
            </div> -->
      <!-- </div> -->
      <!-- <div class="flex-1 px-8"> -->
      <!-- <div class="font-bold mb-2">
              Lunas
            </div>
            <div class="text-2xl">
              {{ fmt.number(dashboardData?.product_variants_count ?? 0) }}
            </div> -->
      <!-- </div> -->
      <!-- </div> -->
      <!-- </app-card> -->

      <app-card title="Produk">
        <div class="grid gap-6 lg:grid-cols-4 divide-x md:grid-cols-2">
          <div>
            <div class="font-bold mb-2">
              Produk
            </div>
            <div class="text-2xl">
              {{ fmt.number(dashboardData?.products_count ?? 0) }}
            </div>
          </div>
          <div>
            <div class="font-bold mb-2">
              Varian
            </div>
            <div class="text-2xl">
              {{ fmt.number(dashboardData?.product_variants_count ?? 0) }}
            </div>
          </div>
          <div>
            <div class="font-bold mb-2">
              Opname Terakhir
            </div>
            <div class="text-2xl">
              <template v-if="dashboardData?.last_stock_opname">
                <template v-if="dashboardData.last_stock_opname.ended_at">
                  {{ fmt.date(dashboardData.last_stock_opname.ended_at, 'd MMMM yyyy HH:mm') }}
                </template>
                <template v-else>
                  <span class="text-primary-500 text-lg">Sedang Berlangsung</span>
                </template>
              </template>
              <span
                v-else
                class="text-sm">
                Belum Pernah
              </span>
            </div>
            <div class="text-xs italic mt-1">
              <template v-if="dashboardData?.last_stock_opname?.ended_at">
                {{ fmt.dateRelative(dashboardData.last_stock_opname.ended_at) }}
              </template>
            </div>
            <template v-if="dashboardData?.last_stock_opname && !dashboardData.last_stock_opname.ended_at">
              <div class="mt-2">
                <app-button
                  :to="{ name: 'stock opname scan', params: { id: dashboardData.last_stock_opname.id } }"
                  class="text-sm flex items-center w-full gap-2">
                  Bantu Input
                  <fa-icon icon="i-far-arrow-right" />
                </app-button>
              </div>
            </template>
          </div>
          <div></div>
        </div>
      </app-card>

      <div>
        <section-product-without-price />
      </div>
    </div>
  </div>
</template>
